import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferGameServiceInitQuery, OfferGameServiceInitVo } from './type';

/**
 * game service offer 上传时 页面需要直接加载的信息
  GET /product/offerManage/getSpuDetail
  接口ID：263628560
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628560
 */
export const getOfferGameServiceInit = (params: OfferGameServiceInitQuery): AxiosPromise<OfferGameServiceInitVo> => {
  return request({
    url: '/product/offerManage/getSpuDetail',
    method: 'get',
    params
  });
};
